import React from "react";

import "./MBDivider.scss";

export const MBDivider = () => <div className="divider" />;
